import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {authHeader} from '../../utils/headers';

const API_BASE = import.meta.env.VITE_APIURL || '';

/**
 * Read model de la vue intervention v2 (INT-02) : GET /interventions/{id}/detail.
 * Servi par l'API via un DTO (ADR-002 api) — état dominant, photos rattachées aux actes / zones,
 * consignes actives au jour du passage, relevé terrain, masquage client déjà appliqué.
 * Coexiste avec le module Redux classique `interventions` (POST) : on ne le touche pas.
 */
export const interventionDetailApi = createApi({
    reducerPath: 'interventionDetailApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE,
        prepareHeaders: (headers) => {
            const token = authHeader();
            if (typeof token === 'string' && token) {
                headers.set('authorization', token);
            }
            headers.set('Accept', 'application/ld+json');
            return headers;
        },
    }),
    tagTypes: ['InterventionDetail'],
    endpoints: (builder) => ({
        getInterventionDetail: builder.query({
            query: (id) => `/interventions/${id}/detail`,
            providesTags: (result, error, id) => [{type: 'InterventionDetail', id}],
        }),
    }),
});

export const {useGetInterventionDetailQuery} = interventionDetailApi;
